import React from 'react';

function Paraguay(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124015)">
        <mask
          id="mask0_800_124015"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124015)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124015"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124015)">
            <path
              d="M22.325 12C22.325 14.0937 20.4086 15.825 18 15.825C15.5914 15.825 13.675 14.0937 13.675 12C13.675 9.90632 15.5914 8.175 18 8.175C20.4086 8.175 22.325 9.90632 22.325 12Z"
              stroke="#272727"
              strokeWidth="0.35"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.625 12C14.625 13.6569 16.136 15 18 15C19.864 15 21.375 13.6569 21.375 12C21.375 11.1144 20.9433 10.3183 20.2566 9.76919C19.6588 9.291 18.8676 9 18 9C17.2701 9 16.5944 9.20594 16.0423 9.55601C15.1844 10.1 14.625 10.9919 14.625 12ZM20.9812 12C20.9812 13.4636 19.6465 14.65 18 14.65C16.3535 14.65 15.0187 13.4636 15.0187 12C15.0187 11.106 15.5168 10.3153 16.2798 9.83537C16.7658 9.52965 17.3593 9.35001 18 9.35001C18.7957 9.35001 19.5186 9.62712 20.0533 10.0787C20.6249 10.5615 20.9812 11.2438 20.9812 12Z"
              fill="#272727"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#F05234"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#3D58DB"
            />
            <path
              d="M16.4439 10.0022L16.764 10.4133C16.0217 10.8701 15.6857 11.4065 15.96 12.3166C16.2317 13.2179 16.8691 13.6653 17.9301 13.6981L17.9106 14.1978C16.6032 14.1574 15.7201 13.6812 15.3842 12.5668C15.0509 11.4611 15.4969 10.5849 16.4439 10.0022Z"
              fill="#73BE4A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 12.315L17.0081 12.9135L17.342 11.8901L16.3951 11.2365L17.5933 11.2025L18 10.2L18.4067 11.2025L19.6049 11.2365L18.658 11.8901L18.9919 12.9135L18 12.315Z"
              fill="#FBCD17"
            />
            <path
              d="M19.3137 10.1759C19.3137 10.1759 20.5807 10.9556 20.125 12.4674C19.6692 13.9792 17.893 14.034 17.893 14.034"
              stroke="#73BE4A"
              strokeWidth="0.5"
            />
            <path
              d="M16.3845 9.04373L16.9097 9.76195L16.3845 9.04373Z"
              fill="#F7FCFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124015">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Paraguay;
